import { useMount } from '@tiger/hooks';
import Icon from '@tiger/icons';
import { FC, useDeferredValue, useMemo, useRef, useState } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import classlist from 'utils/classlist';
import { getSearchCountryData } from 'utils/helper';
import styles from './portalPC.scss';
import { TelcodesCountry } from './type';

interface PortalPCProps {
    className?: string;
    countryData: TelcodesCountry[];
    onChange: (value: string) => void;
    hide(): void;
}

const PortalPC: FC<PortalPCProps> = ({ className, countryData, onChange, hide }) => {
    const countryPCPanelRef = useRef<HTMLDivElement>(null);
    const [searchValue, setSearchValue] = useState<string>('');
    const deferredSearchValue = useDeferredValue(searchValue);
    const filteredData = useMemo(() => {
        const lowerSearchValue = deferredSearchValue.toLowerCase();

        return lowerSearchValue ? getSearchCountryData(countryData, lowerSearchValue) : countryData;
    }, [deferredSearchValue, countryData]);

    useMount(() => {
        const hidePCPanel = ev => {
            if (countryPCPanelRef.current && !countryPCPanelRef.current.contains(ev.target)) {
                hide();
            }
        };

        if (countryPCPanelRef.current) {
            window.addEventListener('click', hidePCPanel, false);
        }

        return () => {
            countryPCPanelRef.current && window.removeEventListener('click', hidePCPanel);
        };
    });

    return (
        <div className={classlist(styles.root, className)} ref={countryPCPanelRef}>
            <InputGroup className={styles.header}>
                <InputGroup.Text className={styles.iconContainer}>
                    <Icon type="search" className={styles.icon} />
                </InputGroup.Text>
                <FormControl
                    className={styles.search}
                    placeholder={__('搜索')}
                    onChange={ev => setSearchValue(ev.target.value)}
                />
            </InputGroup>
            <section className={styles.list}>
                {filteredData.map(({ letter, items }) => (
                    <div key={letter} className={styles.letterList}>
                        <h5 className={styles.title}>{letter}</h5>
                        <>
                            {items.map(({ country_code, tel_code, country }) => {
                                return (
                                    <div
                                        key={country_code}
                                        data-code={tel_code}
                                        className={styles.item}
                                        onClick={() => onChange(tel_code)}>
                                        <span className={styles.country}>{country}</span>
                                        <span className={styles.code}>+{tel_code}</span>
                                    </div>
                                );
                            })}
                        </>
                    </div>
                ))}
            </section>
        </div>
    );
};

export default PortalPC;
